import { DETAILS_FORM_SET_SENDING }
  from 'src/app/redux/actions/registration/account/accountForm';


const initialState = {
  sending: false
};

const accountFormReducer = (state = initialState, action = {}) => ({
  [DETAILS_FORM_SET_SENDING]: () => ({ ...state, ...action.payload })
}[action.type] || (() => state))();


export default accountFormReducer;
